export default __webpack_public_path__ + "static/media/pic2.33698d3d.png";